// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-C":"C_vanlife-roadtrips-C__9Ozk6"};